module.exports = __webpack_public_path__ + "img/trust_thumbnail.702dad4f.jpg";